import type { CreativePlaybook } from "./types"

/** Keep in sync with `@ArrayMaxSize(50)` on `adsetIds` in
 *  apps/api/src/dto/creative-management/analyze.dto.ts. */
export const MAX_ANALYZE_ADSETS = 50

/** Keep in sync with MAX_SIMILARITY_ADSETS_PER_RUN in
 *  apps/api/src/services/creative-management/creative-management.constants.ts.
 *  Similarity playbooks push every ad thumbnail through the LLM, so they are
 *  capped tighter than plain analyze runs. */
export const MAX_SIMILARITY_ADSETS = 15

export const SIMILARITY_PLAYBOOKS: ReadonlySet<CreativePlaybook> = new Set([
  "DUPLICATIVE_LOSERS",
  "TOO_SIMILAR",
])

/** True when the current selection is too large for this playbook to run —
 *  the backend would reject the analyze request outright. */
export function exceedsAdsetCap(
  playbook: CreativePlaybook,
  selectedCount: number,
): boolean {
  const cap = SIMILARITY_PLAYBOOKS.has(playbook)
    ? MAX_SIMILARITY_ADSETS
    : MAX_ANALYZE_ADSETS
  return selectedCount > cap
}
